import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


export interface BreadcrumbData {
  title?: string;
  urls?: { title: string; url: string }[];
  custom?: boolean;
}


@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
  private breadcrumbSubject = new BehaviorSubject<BreadcrumbData>({});
  breadcrumb$ = this.breadcrumbSubject.asObservable();

  setBreadcrumb(data: BreadcrumbData) {
    this.breadcrumbSubject.next(data);
  }
}
